module.exports = __webpack_public_path__ + "static/media/Nurse.5fe891bd.jpg";